import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../menu';
import  config from '../../config';
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class Categoriaitem extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa : currentCompany,
            tipo : currentUserType
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa' : this.state.empresa,
                'tipo' : this.state.tipo,
            }
        }
        fetch(config.servBackEnd+'/categoryitem/', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];

        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (

            <div className="contenedor">
                <Menu></Menu>
                <Jumbotron style={style}>
                    <h1>Modulo Lineas Items</h1>
                </Jumbotron>
                <Button className="plus" size="sm" href="/categorias/crear/" variant="outline-primary">Crear Linea</Button>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>EMPRESA</th>
                            <th>CODIGO</th>
                            <th>DESCRIPCION</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            return <tr key={index + "d0"}>
                                <td key={index + "d2"}>{currentData.ID_EMPRESA}</td>
                                <td key={index + "d4"}>{currentData.CODIGO_CATEGORIA}</td>
                                <td key={index + "d6"}>{currentData.DESCRIPCION_CATEGORIA}</td>
                                <td key={index + "d15"}><Button size="sm" href={"/categorias/crear/?"+currentData.ID_CATEGORIA_ITEMS} variant="outline-primary">Editar</Button></td>
                            </tr>;
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (Categoriaitem);